export default function FormLabel(theme) {
	return {
		MuiFormLabel: {
			styleOverrides: {
				root: {}
			}
		}
	}
}